import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from 'react-helmet-async';
import App from "./App";
import "./index.css";

// Add preload for critical LCP image
const lcpImagePreloadLink = document.createElement('link');
lcpImagePreloadLink.rel = 'preload';
lcpImagePreloadLink.href = '/images/asd5.jpg';
lcpImagePreloadLink.as = 'image';
lcpImagePreloadLink.type = 'image/jpeg';
lcpImagePreloadLink.fetchPriority = 'high';
document.head.appendChild(lcpImagePreloadLink);

// Add preload for critical fonts
const fontPreloadLink = document.createElement('link');
fontPreloadLink.rel = 'preload';
fontPreloadLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
fontPreloadLink.as = 'style';
document.head.appendChild(fontPreloadLink);

// Add font stylesheet after preload
const fontStyleLink = document.createElement('link');
fontStyleLink.rel = 'stylesheet';
fontStyleLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
document.head.appendChild(fontStyleLink);

// Register service worker for PWA and notifications support
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then(registration => {
      console.log('Service Worker registered with scope:', registration.scope);
      
      // Get the environment variables for Firebase
      const firebaseConfig = {
        apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
        authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
        projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
        storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
        appId: import.meta.env.VITE_FIREBASE_APP_ID
      };
      
      // Pass the configuration to the service worker
      if (registration.active) {
        registration.active.postMessage({
          type: 'FIREBASE_CONFIG',
          config: firebaseConfig
        });
      } else {
        // If the service worker is still activating, wait and then send the message
        registration.installing.addEventListener('statechange', (event) => {
          if (event.target.state === 'activated') {
            registration.active.postMessage({
              type: 'FIREBASE_CONFIG',
              config: firebaseConfig
            });
          }
        });
      }
    })
    .catch(error => {
      console.error('Service Worker registration failed:', error);
    });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
